import { c as _c } from "react/compiler-runtime";
import { Loader } from "@justhome/react-ui";
import { DEMODESK_BASE_URL } from "@lib/demodesk";
import { useEffect, useState } from "react";

// react rewrite of this snippet
// <script type="application/javascript" id="demodesk-iframe-inserter">
//   var r="https://demodesk.com";var t=/([.*+?\^${}()|\[\]\/\\])/;function n(e){return e.replace(t,"\\$1")}function e(e){var t=document.cookie.match(RegExp("(?:^|;\\s*)"+n(e)+"=([^;]*)"));return t&&t[1]}function a(e){var t=r+"/book/justhome-2-team/finanzcheck?iframe=true";return e?t+"&hutk="+e:t}var i=document.createElement("iframe");i.style="width: 100%; min-height: 230px; border: none;";i.classList.add("demodesk-demo-templates-page");i.src=a(e("hubspotutk"));var m=document.createElement("script");m.src=r+"/iframe_resize.js";var c=document.getElementById("demodesk-iframe-inserter");var o=c.parentElement;o.replaceChild(i,c);o.insertBefore(m,i.nextSibling);
// </script>

export type DemodeskMeetingScheduledEvent = {
  event: "demodesk.meetingScheduled";
  data: {
    meetingDate: string;
    eventTypeSlug: string;
    hostEmail: string;
    isReschedule: boolean;
    form: {
      guests: Array<any>;
      customer_email: string;
      customer_first_name: string;
      customer_last_name: string;
      customer_company_name: string;
      customer_phone: string;
    };
  };
};
const iFrameContainerId = "demodesk-iframe-inserter";
const isMeetingScheduledEvent = (event: MessageEvent): event is MessageEvent<DemodeskMeetingScheduledEvent> => {
  return event.data.event && event.data.event.indexOf("demodesk.meetingScheduled") === 0;
};
export interface DemodeskMeetingProps {
  applicationId?: string;
  calendarUrl: string;
  onMeetingScheduled: (result: DemodeskMeetingScheduledEvent) => void;
}
const DemodeskMeeting = t0 => {
  const $ = _c(18);
  const {
    applicationId,
    calendarUrl,
    onMeetingScheduled
  } = t0;
  const [isLoading, setIsLoading] = useState(true);
  let t1;
  if ($[0] !== applicationId || $[1] !== calendarUrl) {
    t1 = {
      calendarUrl,
      applicationId
    };
    $[0] = applicationId;
    $[1] = calendarUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [prevMeeting, setPrevMeeting] = useState(t1);
  if (prevMeeting.calendarUrl !== calendarUrl || prevMeeting.applicationId !== applicationId) {
    setPrevMeeting({
      calendarUrl,
      applicationId
    });
    setIsLoading(true);
  }
  let t2;
  if ($[3] !== calendarUrl) {
    t2 = () => {
      const container = document.getElementById(iFrameContainerId);
      if (container) {
        const iframe = document.createElement("iframe");
        iframe.style.cssText = "width: 100%; min-height: 230px; border: none;";
        iframe.className = "demodesk-demo-templates-page";
        iframe.src = calendarUrl;
        const script = document.createElement("script");
        script.src = `${DEMODESK_BASE_URL}/iframe_resize.js`;
        container.innerHTML = "";
        container.appendChild(iframe);
        container.appendChild(script);
        let hasHeightChanged = false;
        const resizeObserver = new ResizeObserver(entries => {
          if (!hasHeightChanged && entries[0]) {
            const {
              height
            } = entries[0].contentRect;
            if (height > 230) {
              hasHeightChanged = true;
              setIsLoading(false);
              resizeObserver.disconnect();
            }
          }
        });
        resizeObserver.observe(container);
      }
      const fallbackTimer = setTimeout(() => {
        setIsLoading(false);
      }, 3000);
      return () => {
        clearTimeout(fallbackTimer);
        if (container) {
          container.innerHTML = "";
        }
      };
    };
    $[3] = calendarUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== applicationId || $[6] !== calendarUrl) {
    t3 = [calendarUrl, applicationId];
    $[5] = applicationId;
    $[6] = calendarUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[8] !== onMeetingScheduled) {
    t4 = () => {
      const handleMessage = event => {
        if (isMeetingScheduledEvent(event)) {
          onMeetingScheduled(event.data);
        }
      };
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    };
    t5 = [onMeetingScheduled];
    $[8] = onMeetingScheduled;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== isLoading) {
    t6 = isLoading && <div className="flex justify-center items-center min-h-[230px]"><Loader size="lg" /></div>;
    $[11] = isLoading;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = isLoading ? "opacity-0 pointer-events-none" : "opacity-100";
  let t8;
  if ($[13] !== t7) {
    t8 = <div id={iFrameContainerId} className={t7} />;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div id="iframe-container">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default DemodeskMeeting;